import styled, { css } from 'styled-components';

import { Responsive, WidthProvider } from 'react-grid-layout';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const StyledResponsiveReactGridLayout = styled(ResponsiveReactGridLayout)`
  position: relative;
  & > div {
    cursor: ${(props) => (props.dragging ? 'grabbing' : 'grab')};
    user-select: none;
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: -2px;
      bottom: -2px;
      left: -2px;
      right: -2px;
      border-radius: 1rem;
      border: ${({ multiSelection, editPainel }) => (editPainel || multiSelection ? 'dashed 2px #a9a9a9' : 'solid 2px transparent')};
    }
    & > *{
      pointer-events: ${(props) => (props.editPainel ? 'none' : 'all')};
    }
    & div > * {
      ${({ multiSelection }) => (multiSelection && css`
        user-select: none;
        pointer-events: none;
      `)}
    }
  }
`;

export const CardWrapper = styled.div`
  ${({ isSelected, theme }) => isSelected && css`
    &:after {
      content: '';
      border-radius: 1rem;
      background: repeating-linear-gradient(
        45deg,
        ${theme.info}5a,
        ${theme.info}5a 10px,
        ${theme.info}8a 10px,
        ${theme.info}8a 20px
      );
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      overflow: hidden;
      pointer-events: none;
    }
  `}
`;

export default StyledResponsiveReactGridLayout;
